// extracted by mini-css-extract-plugin
var _1 = "640px";
var _2 = "790px";
var _3 = "79px";
var _4 = "110px";
var _5 = "72px";
var _6 = "665px";
var _7 = "2";
var _8 = "#cdd3dc";
export { _1 as "controlsMobileWidth", _2 as "controlsStackedWidth", _3 as "menuHeight", _4 as "menuHeightLarge", _5 as "menuHeightMobile", _6 as "modalMobileWidth", _7 as "timelineStrokeWidth", _8 as "timelineTrackColor" }
